import { createContext, useContext, useEffect, useState } from 'react'
import { api, getToken, setToken, clearToken } from '../api.js'

const AuthCtx = createContext(null)

export function AuthProvider({ children }) {
	const [user, setUser] = useState(null)
	const [loading, setLoading] = useState(true)

	useEffect(() => {
		const t = getToken()
		if (!t) {
			setLoading(false)
			return
		}
		api('/api/me')
			.then((res) => setUser(res.user))
			.catch(() => clearToken())
			.finally(() => setLoading(false))
	}, [])

	async function login(email, password) {
		const res = await api('/api/login', {
			method: 'POST',
			auth: false,
			body: { email, password },
		})
		setToken(res.token)
		setUser(res.user)
		return res.user
	}

	function logout() {
		clearToken()
		setUser(null)
	}

	return (
		<AuthCtx.Provider value={{ user, loading, login, logout }}>
			{children}
		</AuthCtx.Provider>
	)
}

export const useAuth = () => useContext(AuthCtx)
